// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "dynamic-image-module--base-text-alt--global--a0a86";
export var baseTextGlobal = "dynamic-image-module--base-text--global--78caf";
export var blockSpacing100 = "dynamic-image-module--block-spacing-100--bcb30";
export var blockSpacing50 = "dynamic-image-module--block-spacing-50--eb423";
export var blockVPadding100 = "dynamic-image-module--block-v-padding-100--d744f";
export var blockVPadding50 = "dynamic-image-module--block-v-padding-50--e2ae9";
export var captionTextGlobal = "dynamic-image-module--caption-text--global--63d7b";
export var cmsRenderedContentGlobal = "dynamic-image-module--cms-rendered-content--global--d6dc6";
export var defaultHSpacingGlobal = "dynamic-image-module--default-h-spacing--global--deb33";
export var fadeInAnimation = "dynamic-image-module--fadeInAnimation--644da";
export var fadeInOnLoadGlobal = "dynamic-image-module--fade-in-on-load--global--6ba9a";
export var fullHeightGlobal = "dynamic-image-module--full-height--global--e1382";
export var fullHeightOmittingNavGlobal = "dynamic-image-module--full-height-omitting-nav--global--1bcb6";
export var headingTextGlobal = "dynamic-image-module--heading-text--global--f6005";
export var image = "dynamic-image-module--image--d61cb";
export var imgContainer = "dynamic-image-module--imgContainer--7981a";
export var ingressTextGlobal = "dynamic-image-module--ingress-text--global--ce6de";
export var linkColorChangeTransitionGlobal = "dynamic-image-module--link-color-change-transition--global--cd682";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "dynamic-image-module--page-heading-text--global--f9b02";
export var paragraphTextGlobal = "dynamic-image-module--paragraph-text--global--83c0f";
export var subheadingTextGlobal = "dynamic-image-module--subheading-text--global--8a029";